module.exports = __webpack_public_path__ + "img/menu.ace2b328.svg";